import GamesSection from './GamesSection';

export default GamesSection;
